import { useState, useEffect, useCallback, useRef } from "react";

function getWindowDimensions() {
  const { innerWidth: width } = window;
  return {
    width,
  };
}

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const resizeTimeout = useRef<number | null>(null);

  const handleResize = useCallback(() => {
    // Clear any existing timeout
    if (resizeTimeout.current) {
      window.clearTimeout(resizeTimeout.current);
    }

    // Set a new timeout
    resizeTimeout.current = window.setTimeout(() => {
      setWindowDimensions(getWindowDimensions());
    }, 150); // Increased debounce time to 150ms
  }, []);

  useEffect(() => {
    // Add event listener
    window.addEventListener("resize", handleResize);
    
    // Cleanup function
    return () => {
      // Remove event listener
      window.removeEventListener("resize", handleResize);
      
      // Clear any pending timeout
      if (resizeTimeout.current) {
        window.clearTimeout(resizeTimeout.current);
      }
    };
  }, [handleResize]);

  return windowDimensions;
};
